export const TITLES = [
  { label: "Mx", value: "Mx" },
  { label: "Mr", value: "Mr" },
  { label: "Mrs", value: "Mrs" },
  { label: "Miss", value: "Miss" },
  { label: "Dr", value: "Dr" },
  { label: "Earl", value: "Earl" },
  { label: "Lady", value: "Lady" },
  { label: "Lord", value: "Lord" },
  { label: "Countess", value: "Countess" },
  { label: "Ms", value: "Ms" },
  { label: "Capt.", value: "Capt." },
  { label: "Sir", value: "Sir" },
  { label: "Sis.", value: "Sis." },
  { label: "Dame", value: "Dame" },
  { label: "Revd", value: "Revd" },
];
